/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Progress } from "./Progress";
export const EventAttributes = core.serialization.object({
    targetUpdatedAt: core.serialization.date().optional(),
    progress: Progress.optional(),
});
